import { graphql } from '@/gql';
import type { GetLossPreventionAlertsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getLossPreventionAlerts = async ({ assigneeQuery, status, pagination }: GetLossPreventionAlertsQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query GetLossPreventionAlerts($assigneeQuery: String, $pagination: PaginationInputType, $status: String!) {
        getLossPreventionAlerts(assigneeQuery: $assigneeQuery, pagination: $pagination, status: $status) {
          __typename
          count
          rows {
            assigneeId
            channelId
            firstName
            lastName
            props
            status
            id
            component
            updatedAt
            createdAt
          }
        }
      }
    `),
    variables: {
      assigneeQuery,
      status,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getLossPreventionAlerts;
};
